/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseTileFragment} from '@amblique/contentful/app/contentful/fragments/tile/base-tile.fragment';
import {ImageFragment} from '@amblique/contentful/app/contentful/fragments/image/image.fragment';

export const FullTileFragment = gql`
  ${BaseTileFragment}
  ${ImageFragment}

  fragment FullTileFragment on Tile {
    ...BaseTileFragment

    image {
      ...ImageFragment
    }
  }
`;
